/**
 * Extracts the root field name from an error key.
 * e.g., "contactIds.0.email" → "contactIds"
 */
export const getErrorRootName = (field: string) => field.split('.').at(0) ?? '';
